module.exports = __webpack_public_path__ + "static/img/icon_lingdan.59c055c4.png";